import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";

function raiseError(type = "ERROR_CLIENT", error = null, customMessage = "") {
  const errorId = getUUID();

  if (!error) {
    if (!customMessage || typeof customMessage !== "string")
      customMessage =
        "Encountered an unknown error. Please contact the system administrator.";
    error = {
      isSystemException: false,
      type,
      targetSite: "",
      message: "",
      innerException: "",
      customMessage,
    };
  }

  const newError = {
    errorId,
    type,
    error,
    generatedOn: new Date().toISOString(),
    isAcknowledged: false,
  };
  actionScripts.ADD_ERROR.run(newError);
  console.error(type, error);
}

export default raiseError;
